// Every spinner turns in step with the first one, so one that takes over from another (the page's placeholder, the
// player's, the buffering indicator) goes on turning instead of starting over.
let origin = null;

// The page's placeholder, before the player replaces it: its spinner sets the step.
export function takeSpinnerPhase(element) {
  const [animation] = element.getAnimations?.({ subtree: true }) ?? [];
  origin = animation?.startTime ?? origin;
}

export function keepSpinnerInStep(element) {
  for (const animation of element.getAnimations?.({ subtree: true }) ?? []) {
    origin ??= animation.startTime ?? document.timeline.currentTime;
    if (origin !== null) animation.startTime = origin;
  }
}
